var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMetrics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill:red;}.c{fill:#707070;}.d{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb5cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b36fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-291 -1594.895)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 60,
    height: 60,
    transform: "translate(291 1594.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1,1V59H59V1H1M0,0H60V60H0Z",
    transform: "translate(291 1594.895)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.627,35.314a3.314,3.314,0,0,0-6.627,0V70.107a8.282,8.282,0,0,0,8.284,8.284H49.7a3.314,3.314,0,1,0,0-6.627H8.284a1.662,1.662,0,0,1-1.657-1.657ZM45.459,57.577a2.488,2.488,0,0,0,4.246-1.76V44.426a2.479,2.479,0,0,0-2.485-2.485h-11.4a2.488,2.488,0,0,0-1.76,4.246l3.355,3.355-5.933,5.933-7.6-7.6a3.319,3.319,0,0,0-4.691,0L10.9,56.158a3.317,3.317,0,0,0,4.691,4.691l5.944-5.933,7.6,7.6a3.319,3.319,0,0,0,4.691,0l8.284-8.284Z",
    transform: "translate(294.75 1569.699)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetrics);
export default __webpack_public_path__ + "static/media/iconMetrics.11612bfd424177b75fffb61a2baa4594.svg";
export { ForwardRef as ReactComponent };